import { create } from 'zustand';

import { CardReadState } from '@/models/CardReader.ts';
import { DailyAppointment } from '@/models/appointment/Appointment.ts';

export enum WalkInTab {
    SEARCH = 'search',
    READ_CARD = 'read-card',
    NEW_PATIENT = 'new-patient',
}

export enum WalkInModalMode {
    BOOK = 'book',
    ADD_PATIENT_TO_APPOINTMENT = 'add-patient-to-appointment',
    CREATE_PATIENT = 'create-patient',
}

interface WalkInStore {
    // State
    active_tab: WalkInTab | undefined;
    is_user_selected: boolean;
    is_loading: boolean;
    card_read_state: CardReadState | undefined;
    selected_instance_id: string | undefined;
    selected_appointment: DailyAppointment | undefined;

    // Actions
    setActiveTab: (tab: WalkInTab | undefined) => void;
    setIsUserSelected: (selected: boolean) => void;
    setLoading: (loading: boolean) => void;
    setSelectedInstanceId: (instance_id: string | undefined) => void;
    setSelectedAppointment: (appointment: DailyAppointment | undefined) => void;
    resetAllData: () => void;
}

const initial_state = {
    active_tab: WalkInTab.SEARCH,
    is_user_selected: false,
    is_loading: false,
    card_read_state: undefined,
    selected_instance_id: undefined,
    selected_appointment: undefined,
};

export const useWalkInStore = create<WalkInStore>((set) => ({
    // Initial state
    ...initial_state,

    // Actions
    setActiveTab: (tab): void => set({ active_tab: tab }),
    setIsUserSelected: (selected): void => set({ is_user_selected: selected }),
    setLoading: (loading): void => set({ is_loading: loading }),
    setSelectedInstanceId: (instance_id): void => set({ selected_instance_id: instance_id }),
    setSelectedAppointment: (appointment): void => set({ selected_appointment: appointment }),
    resetAllData: (): void =>
        set({
            ...initial_state,
        }),
}));
